// extracted by mini-css-extract-plugin
export default {"description":"MetaProgramManagerAccessControlView_description__CikkX","divider":"MetaProgramManagerAccessControlView_divider__6CU0+"};